import { connect } from 'react-redux';
import defaultSkinGuide from 'defaults/skins';

const mapStateToProps = ((state) => {
    const skin = state.colorProfiles;
    const storylineId = state.storyline?.storylineDetails?.id || 1; // Default to storyline 1

    // Get storyline-specific theme
    let skinGuide = defaultSkinGuide;
    
    // Check if we have storyline-specific themes available
    if (defaultSkinGuide.storylineThemes && defaultSkinGuide.storylineThemes[storylineId]) {
        skinGuide = {
            ...defaultSkinGuide,
            globalProfiles: {
                ...defaultSkinGuide.storylineThemes[storylineId].globalProfiles
            }
        };
    }

    // Apply any custom overrides from colorProfiles state
    if (skin !== undefined) {
        // skinGuide = skinGuide.mergeDeep(skin);
        skinGuide = {
            globalProfiles: {
                ...skinGuide.globalProfiles,
                ...skin.globalProfiles
            },
            entityProfiles: [],
            fontFamily: {
                ...skinGuide.fontFamily,
                ...skin.fontFamily
            }
        }
    }

    return {
        skinGuide
    };
});

const mapDispatchToProps = () => ({})

const mergeProps = (propsFromState, propsFromDispatch, ownProps) =>({
    ...propsFromState,
    ...propsFromDispatch,
    ...ownProps
})

const applySkin = (WrappedComponent) => connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(WrappedComponent);

export default applySkin;